import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KIToolsUser } from '@shared/index';
import { firstValueFrom } from 'rxjs';

/** Bot-Login und Gast-Zugriff (`RAGAI.BOTMANAGER`-nahe Login-Funktionen). */
@Injectable({
  providedIn: 'root'
})
export class BotLoginService {

  constructor(private http: HttpClient) { }

  /**
   * Prüft das Bot-Passwort und meldet den Nutzer am Bot an.
   * @param botId ID des Bots.
   * @param pw Das eingegebene Passwort.
   * @returns Status der Anmeldung und optional eine Meldung.
   */
  public async loginBot(botId: string, pw: string) {
    return await firstValueFrom(this.http.post<{ status: string, message?: string }>("/api/toolbox/bot/user/checkbotpw/" + botId, { pw }));
  }

  /**
   * Erstellt einen temporären Gast-Zugang zum Bot ohne Passwort.
   * @param botId ID des Bots.
   * @param guestId Eindeutige ID des Gasts.
   * @param metadata Zusätzliche Metadaten zum Gast.
   * @returns Der erstellte Nutzer und dessen Zugriffstoken.
   */
  public async instantAccessBot(botId: string, guestId: string, metadata: string) {
    return await firstValueFrom(this.http.post<{ createdUser: KIToolsUser, userToken: string }>("/api/toolbox/auth/join/" + botId, { guestId, metadata }));
  }
}
